import "./faq.css";
import Accordion from "react-bootstrap/Accordion";

const Faq = () => {
  return (
    <div className="faq" id="faq">
      <h2 className="home-headers">Frequency Asked Questions</h2>

      <div className="faq__container">
        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header>What is a QR Code?</Accordion.Header>
            <Accordion.Body>
              <p>
                QR codes are, like those 2D barcodes that you can scan using
                your smartphone or other digital devices. They have the ability
                to store types of information such as website addresses, phone
                numbers and text messages. You often come across them in
                marketing campaigns. They also find utility in areas like
                inventory tracking and managing customer loyalty programs.
              </p>
              <p>
                I remember this one time when I was strolling down the street
                and noticed a QR code on a poster advertising a restaurant. Out
                of curiosity I decided to scan it with my phone. It instantly
                directed me to the restaurants website. It was quite convenient
                as I got to check out their menu make a reservation and even
                snagged a coupon for a 10% discount on my meal.
              </p>
              <p>
                QR codes really offer an effortless and speedy way to access
                information.. There's something, about scanning them!
              </p>
              <p>
                In summary QR codes present an user friendly means of obtaining
                information{" "}
              </p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <Accordion.Header>How do I scan a QR Code?</Accordion.Header>
            <Accordion.Body>
              <p>
                To scan a QR code you will need a smartphone or any other device
                equipped with a camera. Most smartphones have a built QR code
                scanner. There are also third party apps available, for scanning
                QR codes.
              </p>
              <p>Here's how to scan a QR code using your smartphone;</p>
              <ul>
                <li>Open the camera app on your smartphone.</li>
                <li>Aim the camera towards the QR code.</li>
                <li>
                  Ensure that the entire QR code is visible within the cameras
                  viewfinder.
                </li>
                <li>
                  Your smartphone will automatically. Provide information about
                  the QR code.
                </li>
                <li>
                  Once decoded you can access the content linked to the QR code.
                </li>
              </ul>
              <p>
                If you're using a third party app, for scanning QR codes the
                instructions may vary slightly. Overall the process remains
                similar.
              </p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2">
            <Accordion.Header>How do I create a QR Code?</Accordion.Header>
            <Accordion.Body>
              <p>
                You can create a QR Code for <b>free</b> using our QR Code
                generator. Simply create an account or login with your Google
                account and proceed to the QR Creation page. There you will be
                able to choose what URL the QR Code will send the user to and
                you can customize the QR code to your liking.
              </p>
              <p>
                After you've created your QR code with us, you can download the
                QR code or edit it whenever you feel like it.
              </p>
              <p>
                If you have a Premium or Business plan then you can also track
                your QR codes analytics.
              </p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3">
            <Accordion.Header>
              How can QR Codes help my business?
            </Accordion.Header>
            <Accordion.Body>
              <p>
                QR codes have a multitude of applications, for businesses. Here
                are a few examples:
              </p>
              <p>
                <b>Marketing and advertising: </b> Businesses can leverage QR
                codes to promote their products and services directing customers
                to websites and gathering customer data. For instance a business
                could include a QR code on flyers or advertisements that leads
                to a landing page with information about an offering.
                Alternatively they could incorporate QR codes onto business
                cards to link recipients to their website or social media
                profiles.
              </p>
              <p>
                <b>Customer service: </b>By utilizing QR codes businesses can
                enhance customer support. Streamline communication channels. For
                example placing a QR code on receipts could provide customers
                with access to surveys for feedback purposes. Additionally
                embedding QR codes on product labels allows customers to scan
                them and gain access to videos or FAQs.
              </p>
              <p>
                <b>Payment processing: </b>Employing QR codes enables businesses
                to seamlessly accept payments for products and services. This
                method proves convenient in environments where smooth
                transactions are desired.
              </p>
              <p>
                <b>Inventory management: </b>QR codes play a role, in inventory
                tracking and supply chain management.For instance lets consider
                a situation where a business decides to incorporate QR codes on
                their products. These QR codes would be connected to a database
                containing information, like quantity, location and expiration
                date. Such an approach allows businesses to effectively monitor
                their inventory levels and promptly detect any issues.
              </p>
              <p>
                <b>Employee training & communication: </b>Furthermore QR codes
                can also prove beneficial, for communication and employee
                training purposes. For instance a business could utilize QR
                codes placed on bulletin boards that link to documents outlining
                company policies or procedures. Similarly QR codes placed on
                training manuals could direct employees to video tutorials.
              </p>
              <p>
                all it is evident that QR codes offer immense versatility as
                they can significantly enhance business efficiency improve
                customer experience and ultimately contribute towards increased
                sales.
              </p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="4">
            <Accordion.Header>
              How long are QR Codes valid for?
            </Accordion.Header>
            <Accordion.Body>
              <p>
                QR Codes are permanent and last forever. They will only die if
                you decide to delete the QR Code from your account.
              </p>
              <p>
                If you have a Premium or Business account and use our QR Code
                tracking analytics then you will loose access to this feature if
                you cancel your subscription.
              </p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="5">
            <Accordion.Header>
              Can I modify my QR Code after I've created them?
            </Accordion.Header>
            <Accordion.Body>
              <p>
                Yes, Premium and Business users can modify their QR Codes after
                they've been generated.
              </p>
              <p>
                Normally QR Codes cannot be modified after they're created,
                however we use URL fowarding which allows our Premium users to
                change the link which QR Codes forward to
              </p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="6">
            <Accordion.Header>
              Can I track my visitors with QR Codes?
            </Accordion.Header>
            <Accordion.Body>
              <p>
                Yes, our premium users can track the number of visitors that
                scan their QR Codes.
              </p>
              <p>
                They can also view detailed analytics such as the geographic
                location of their visitors and the type of device they are
                using.
              </p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="7">
            <Accordion.Header>Can I customize my QR Codes?</Accordion.Header>
            <Accordion.Body>
              <p>
                With QR Sharp you can customize the design of your QR Codes, you
                can change the shapes, colours, size and file type of QR Codes.
              </p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="8">
            <Accordion.Header>
              Why should I use QR Sharp instead of a competitor?
            </Accordion.Header>
            <Accordion.Body>
              <p>
                The main advantage of using QR Sharp is that premium members can{" "}
                <b>view detailed analytics about visitors</b> who scan their QR
                Codes. This includes analytics such as the geographic location
                of their visitors and the type of device they are using. This
                information can be useful in making business decisions.
              </p>
              <p>
                Another advantage of QR Sharp is that{" "}
                <b>you can edit your QR Codes</b> after they've been created.
                This means that if you change the URL of your website then you
                can also change the URL that your QR Code points to, so that
                visitors are sent to the correct URL.
              </p>
              <p>
                When using QR Sharp you can{" "}
                <b>customize your QR Codes design</b> to your liking to brand
                your QR Codes and make them visually appealing and attractive to
                visitors.
              </p>
              <p>
                If you're creating QR codes using a free service or on your own
                then you won't get any help with it. When generating QR Codes
                with us, you can email us for <b>technical support</b>. Premium
                and Business users will recieve priority support with response
                times of just a few hours.
              </p>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </div>
  );
};

export default Faq;
